import {TitlePage} from "../../../shared";
import {isMobileDevice} from "../../../../utils/utils";
import ButtonMenu from "../../buttonMenu/buttonMenu";
import auth from "../../../../utils/authentication";
import React from "react";
import {useChatStore} from "../../../chatbot/store/chatbotStore";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import group from "../../../group";

const AppExtraOptions = ({hideTitle, userPreferences}) => {
    const {
        hasPermission
    } = useChatStore();
    const intl = useIntl();
    const userGroups = useSelector(group.selectors.userGroups);
    const verified = auth.currentUser?.emailVerified;


    return (
        <div className="col-12" style={{
            height: '100%',
            overflowY: 'auto',
        }}>
            {!hideTitle && <>
                <div className="mb-3"/>
                <TitlePage icon="fa-solid fa-link" title="Links"
                           leftClass="col-12"/>
            </>}
            <div style={{
                display: 'grid',
                gridTemplateColumns: "repeat(1, 1fr)",
                gap: '10px',
                justifyItems: 'center'
            }}>
                <ButtonMenu classIcon={"fa-solid fa-circle-user"} text="Configuración"
                            route={'/my-profile/config'} className="w-100"
                            forceBig={true} verified={auth.currentUser}/>
                <ButtonMenu classIcon={"fa-solid fa-lock"} text="Zona privada"
                            route={'/my-profile/private'} className="w-100"
                            forceBig={true} verified={auth.currentUser}/>
                {isMobileDevice() && !userPreferences.barButtons.some(x => x.id == "drive") &&
                    <ButtonMenu key="drive" classIcon={"fa-solid fa-hard-drive"}
                                text={intl.formatMessage({id: `app.my-drive`})}
                                route={'/my-drive/*'} className="w-100"
                                forceBig={true} verified={verified}/>}
                <ButtonMenu classIcon={"fa-solid fa-desktop"} text="Disp. TV"
                            route={'/my-profile/devices'} className="w-100"
                            forceBig={true} verified={auth.currentUser}/>
                {hasPermission("viewUsers") &&
                    <ButtonMenu route="/admin-conf/users" text="Conf. Usuarios" forceBig={true}
                                classIcon="fa-solid fa-gears" className="w-100"
                                verified={auth.currentUser}></ButtonMenu>}
                {hasPermission("towersstreamDashboard") &&
                    <ButtonMenu route="/squadflix/towersstream/dash" text="Towers Stream" forceBig={true}
                                classIcon="fa-solid fa-table-columns" className="w-100"
                                verified={auth.currentUser}></ButtonMenu>}
                {hasPermission("viewSquadflixLogs") &&
                    <ButtonMenu route="/squadflix-logs" text="Squadflix Views" forceBig={true}
                                classIcon="fa-solid fa-tower-observation" className="w-100"
                                verified={auth.currentUser}></ButtonMenu>}
                <ButtonMenu classIcon={"fa-solid fa-people-group"} text={intl.formatMessage({id: `app.group`})}
                            route={'/groups'} alert={!!userGroups?.groupInvites?.length} className="w-100"
                            forceBig={true} verified={auth.currentUser}/>
            </div>
        </div>
    );
}

export default AppExtraOptions;
